import { useClinic } from "@clinic/clinicQueries";
import { clinicDayKey } from "@utils/clinic-day";
import { useNow } from "@utils/use-now";

/** On the shared 30s tick, so `todayKey` rolls over at the clinic's midnight. */
export const useClinicDay = () => {
  const timeZone = useClinic().data?.timezone;
  return { todayKey: clinicDayKey(useNow(), timeZone) };
};
